import { type EpochAttributes } from './generated/EpochAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';

interface Epoch extends EpochAttributes {}

@model
class Epoch extends ApplicationModel {
  // Start auto-generated
  static typename: 'Epoch' = 'Epoch';
  get typename(): 'Epoch' {
    return 'Epoch';
  }

  static internalTypename: 'Epoch' = 'Epoch';
  get internalTypename(): 'Epoch' {
    return 'Epoch';
  }

  static fields = {
    archived: attr({ readable: true }),
    createdAt: attr({ readable: true }),
    name: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
  };
  // End auto-generated
}

export default Epoch;
